module.exports = __webpack_public_path__ + "img/leaf-left2.cdaff964.png";